import { calculateAge, zipCodeToState } from '@shared';
import { carescoutAvailableStates } from '@shared/carrierStateAvailability';

export const MIN_ELIGIBLE_AGE_10PAY_SINGLE_PAY = 40;
export const MAX_ELIGIBLE_AGE_CARESCOUT = 65;

export function getShowTraditionalLTCOptions(
  clientZipCode: string,
  clientBirthDate: string | Date,
) {
  const state = zipCodeToState(clientZipCode);
  const clientAge = calculateAge(new Date(clientBirthDate));
  return (
    carescoutAvailableStates.includes(state.stateAbbreviation as any) &&
    clientAge <= MAX_ELIGIBLE_AGE_CARESCOUT
  );
}

export function getShowSinglePayAnd10Pay(
  hideSinglePayAnd10PayFlag: boolean | undefined,
  clientBirthDate: string | Date,
) {
  const clientAge = calculateAge(new Date(clientBirthDate));
  return !hideSinglePayAnd10PayFlag && clientAge >= MIN_ELIGIBLE_AGE_10PAY_SINGLE_PAY;
}

export function getHideSinglePayAnd10Pay(
  hideSinglePayAnd10PayFlag: boolean | undefined,
  clientBirthDate: string | Date,
) {
  const clientAge = calculateAge(new Date(clientBirthDate));
  return !!hideSinglePayAnd10PayFlag || clientAge < MIN_ELIGIBLE_AGE_10PAY_SINGLE_PAY;
}
